import Text from "../icons/text.svg";
import Visualization from "../icons/visualization.svg";
import Map from "../icons/map.svg";

export const API_URL =
  "https://gist.githubusercontent.com/kabaros/da79636249e10a7c991a4638205b1726/raw/fa044f54e7a5493b06bb51da40ecc3a9cb4cd3a5";

export const Icons = {
  TEXT: Text,
  VISUALIZATION: Visualization,
  MAP: Map,
};
